module.exports = __webpack_public_path__ + "media/images/icons/icon_checked_white-133883208fa636918345b7018090710e.svg";